import { z } from "zod";
import { BackdropSchema } from "../../fragments/Backdrop";
import { BladeCommonSchema } from "../common";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
export const BasicBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
});
export const BasicBladeTypeValues = ["fullWidthImage"];
export const BasicBladeTypesSchema = z.enum(BasicBladeTypeValues);
export const BasicBladeTypes = BasicBladeTypesSchema.enum;
export const FullWidthImageBladesContractSchema = BasicBladeSchema.extend({
    type: BasicBladeTypesSchema,
});
export const FullWidthImageContractSchema = BasicBladeSchema.extend({
    type: z.literal(BasicBladeTypes.fullWidthImage),
});
//# sourceMappingURL=index.js.map